/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "../contactResponseDtoSchema";
import { toggleContactMonitoringDtoSchema } from "../toggleContactMonitoringDtoSchema";
import { z } from "zod/v4";

export const setContactMonitoringPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const setContactMonitoringHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Toggle whether this contact is synced to Radar
 */
export const setContactMonitoring200Schema = z.lazy(() => contactResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const setContactMonitoring401Schema = z.any()

export const setContactMonitoringMutationRequestSchema = z.lazy(() => toggleContactMonitoringDtoSchema)

export const setContactMonitoringMutationResponseSchema = z.lazy(() => setContactMonitoring200Schema)